import axios from 'axios'

const PATH = 'https://share.b1g1.com/share'

const shareAPI = {
  save (data) {
    return new Promise((resolve, reject) => {
      axios.post(PATH, data).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  }
}

export default shareAPI



// WEBPACK FOOTER //
// ./src/api/share.js